<div class="modal-header">
    <h4 class="modal-title">Godkendte sager der ikke er afsluttet efter 50 dage</h4>
    <button (click)="onDismiss()" type="button" data-bs-theme="dark" class="btn-close" aria-label="Close" tabindex="-1"></button>
</div>

<div class="modal-body">
    <table class="table table-hover table-striped table-sm">
        <thead>
            <th scope="col">Kundenr</th>
            <th scope="col">Navn</th>
            <th scope="col">Ydelse</th>
            <th scope="col">Beskrivelse</th>
            <th scope="col">LA konkluderet</th>
            <th scope="col">Dage siden</th>
            <th scope="col">Af</th>
        </thead>
        <tbody>
            <tr *ngFor="let client of d60"
            class="clickable"
            (click)="onOpenClient(client)">
                <td>{{client?.glkundenr}}</td>
                <td>{{client.navn1}}</td>
                <td>{{client.ydelse}}</td>
                <td>{{client.beskrivelse}}</td>
                <td>{{client.konk_la_den | date:'dd-MM-yyyy'}}</td>
                <td>{{client.dage_siden}}</td>
                <td>{{client.konk_la_af}}</td>
            </tr>
        </tbody>
    </table>
</div>
